import servicesConfig, { CustomAxiosHeaders } from '../config/services'
import { requests } from '.'
import { AxiosResponse } from 'axios'

// Configure request setup
const serviceName = 'VoiceAIService'
const host = servicesConfig.VoiceAI
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

// Helper function to handle response
const responseBody = (res: AxiosResponse) => res.data

// Define service object with methods
const VoiceAIService = {
  isAIAgentsEnabled: async (companyId: string, locationId: string): Promise<boolean> => {
    try {
      const url = `/feature-flags/ai-agents?companyId=${companyId}&locationId=${locationId}`;
      const response = await request().get(url).then(responseBody);
      return response?.isEnabled || false
    } catch {
      return false
    }
  }
}

export default VoiceAIService
